import { render, staticRenderFns } from "./EmailItem.vue?vue&type=template&id=6fa5d194&scoped=true&lang=pug&"
import script from "./EmailItem.vue?vue&type=script&lang=js&"
export * from "./EmailItem.vue?vue&type=script&lang=js&"
import style0 from "./EmailItem.vue?vue&type=style&index=0&id=6fa5d194&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa5d194",
  null
  
)

export default component.exports